<template>
    <div>
        <MainHeader />
        <div class="page">
            <div class="container">
            <div class="row">
                <div class="col" style="padding:0px;">
                    <div class="factsheet-status-error">
                        <p><strong>This old factsheet is no longer available!</strong></p>
                        <p>
                            You are seeing this error page because Geofolio has undergone a big update recently and we've 
                            decided that we can't keep all the old factsheets online and up-to-date anymore. If you want,
                            we can generate a new version of the factsheet again for you. 
                        </p>
                        <p>
                            Please e-mail info@geofolio.org and we'll sort if you mention the old factsheet ID 
                            ({{factsheet_uuid}}) or generate a new one yourself from the homepage by drawing or uploading an 
                            area of interest.
                        </p>
                        <p>
                            Apologies for the inconvenience!
                        </p>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  export default {
    name: 'about',
    components: {
      MainHeader, Footer
    },
    data() {
        return {
            factsheet_uuid: this.$route.params.factsheet_uuid
        }
    }
  }
</script>

<style scoped>

div.page {
    font-size:1.1em;
    color:#666;
}
h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}
p {
    line-height:1.4em;
}
div.page {
    font-size:1.5em;
}
div.factsheet-status-notice {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#666;
    border:2px solid #ffd152;
    background-color:#ffffe4
}
div.factsheet-status-error {
    margin:20px 0px;
    padding:20px 20px 6px 20px;
    font-size:0.8em;
    border-radius:0px;
    color:#e50000;
    border:2px solid #e50000;
    background-color:#fff0f0;
}
</style>